import React from 'react'
import Header from '../Header/Header'
import { Box } from '@mui/material'
import Footer from '../Footer/Footer'

function Layout({ children }) {
    return (
        <Box  className='w-100 m-0 p-0 h-100'   overflow={'hidden'}>
            <Header />
            <Box  py={{xs:1,md:"50px",lg:'70px'}} className='w-100 delay-content m-0' px={{xs:1,lg:4}}>
                {children}
            </Box>
            <Box className='mt-5'>
                <Footer />
            </Box>
        </Box>
    )
}

export default Layout
